// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/


;globalThis["SENTRY_RELEASE"] = {"id":"3b066e74a823f1f05dd2546b57d0a6af46f0bb05"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.35";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/assets/officedirectory";globalThis["_sentryAssetPrefix"] = "/assets/officedirectory";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';
// Sentry initialization moved to SentryClientInit.ts
// Sentry initialization moved to SentryClientInit.ts

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
